import PropTypes from "prop-types"
import React, { createContext, useEffect } from "react"

import { useToast } from "src/hooks/use_toast"

import ContractGroupTabLayout from "./ContractGroupTabLayout"
import Contracts from "./Contracts"

export const ContractGroupContext = createContext(null)

const ContractGroup = ({
  archivedGroupsPagePath,
  attachments,
  canUpdate,
  group,
  marinaName,
  namedRates,
  selectedContractId,
  templates,
  templatesPath,
}) => {
  const showToast = useToast()

  useEffect(() => {
    if (selectedContractId) {
      showToast(
        "Your contract quote has been submitted for processing and will be ready to send once it is fully processed.",
        { type: "success" }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ContractGroupContext.Provider
      value={{
        archivedGroupsPagePath,
        attachments,
        canUpdate,
        group,
        marinaName,
        namedRates,
        templates,
        templatesPath,
      }}
    >
      <div className="px-2 xl:px-6">
        <div className="grid grid-cols-12 gap-3 pb-36">
          <div className="col-span-12 flex flex-col self-start border bg-white xl:col-span-5 print:hidden">
            <ContractGroupTabLayout />
          </div>
          <div className="col-span-12 xl:col-span-7 print:col-span-12">
            <Contracts />
          </div>
        </div>
      </div>
    </ContractGroupContext.Provider>
  )
}

ContractGroup.propTypes = {
  archivedGroupsPagePath: PropTypes.string.isRequired,
  attachments: PropTypes.array,
  canUpdate: PropTypes.bool.isRequired,
  group: PropTypes.object.isRequired,
  namedRates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      amount: PropTypes.number,
      taxRate: PropTypes.number,
    })
  ).isRequired,
  marinaName: PropTypes.string.isRequired,
  selectedContractId: PropTypes.string,
  templates: PropTypes.array.isRequired,
  templatesPath: PropTypes.string.isRequired,
}

export default ContractGroup
